function loadRecaptcha() {
    grecaptcha.execute(recaptchaKey,
        { action: 'contact' }).then(function (token) {
        var recaptchaResponse = document.getElementById('contact_recaptcha');
        recaptchaResponse.value = token;
    });
}
if (typeof grecaptcha != 'undefined') {
    grecaptcha.ready(function () {
        loadRecaptcha();
    });
}
$(document).on('submit', 'form.contact-form', function (e) {
    e.preventDefault();

    $('.linkSubmit').addClass('D(n)');
    $('.form-loader').removeClass('D(n)');

    var form = $(this);

    $.post('/contacts/send', form.serializeArray(), function (data) {
        if (data.result) {
            $("#modal-form-success-contact").modal('show');
        }
        $('#form-wrapper').html(data.html);
        loadRecaptcha();
    });
});
